<template>
  <div class="drug-register-view view">
    <div class="panel" v-if="!notReady">
      <h3 class="panel-header">{{ $resident({ capitalize: true }) }} Search</h3>
      <div class="drug-register-table table-container" style="width: 95.5vw; overflow: hidden;">
        <div v-if="$store.state.user.role.permissions.includes('can_view_resident')">
          <div class="filters" style="display: flex; align-items: center;">
              <div style="width: 40%;">
                  <input v-model="searchTerm" v-on:keyup="debounceSearchForPatient(searchTerm)" v-on:keyup.enter="()=>{debounceSearchForPatient.clear(); if(!searchTerm || searchTerm){searchForPatient()}}" :placeholder="'Enter ' + $resident({ capitalize: true }) + ' name or Medicare Number'" style="position: relative; width:100%" />
              </div>
              <button class="regular-button submit-button" style="margin-left: 10px; margin-right: 10px;"
              @click="()=>{if(!searchTerm || searchTerm){searchForPatient()}}">Search</button>

              <button class="button clear-button" @click="clearPatients()">Clear</button>
              <div style="margin-left: 50px; display: flex; align-items: center;">
                <Checkbox inputId="binary" v-model="includeInactive" :binary="true" @change="setInactive()" />
                <label for="binary" style="margin-left: 2px; margin-right: 15px;">Include inactive {{ $resident({ plural: true }) }}</label>

                <Checkbox inputId="searchAll" v-model="searchAll" :binary="true" @change="setSearchAll()" />
                <label for="searchAll" style="margin-left: 2px;">Search all {{ $resident({ plural: true }) }}</label>
              </div>

              <button class="blue-button" style="margin-left: 10px; margin-right: 10px; display: flex; align-items: center" v-if="$store.state.user.integration_id"
              @click="displayResidentSyncModal = true"><i class="pi pi-sync"></i>Sync {{ $resident({ plural: true, capitalize: true }) }}</button>

          <div class="pagination-links" v-if="sortedPatients && sortedPatients.length" style="margin-left: auto; display: flex; align-items: center; gap: 10px;">
            <p class="pagination-arrow" v-show="$store.state.patients.current_page > 1" @click="displayPage(form.page - 1)"> &larr; </p>
            <p style="font-weight: bold; margin: 0;">Page {{$store.state.patients.current_page}} of {{$store.state.patients.page_count}}</p>
            <p class="pagination-arrow" v-show="$store.state.patients.current_page < $store.state.patients.page_count" @click="displayPage(form.page + 1)"> &rarr; </p>
          </div>
          </div>

          <div style="overflow-y: scroll; max-height: 90vh" v-if="$store.getters.getPatients && $store.getters.getPatients.length">
            <div v-for="(item, index) in sortedPatients"  :key="index">
              <router-link 
              class="patient-result" :to="'/patient/'+item.uuid">
                <div class="individual-patient-container" style="width: 100%; background-color: transparent; position: relative;">
                    <div v-if="item.personal_information?.similar_sounding_name" class="similar-name-tag-top">⚠️ Similar Sounding Name</div>
                    <div class="patient-result-image" >
                      <img v-if="item.image_information && item.image_information.url" onerror="this.onerror=null; this.className='resident-image-default resident-image small'" class="resident-image small" :src="item.image_information.url" alt="ss" style="max-height: 100px; max-width: 100px;">
                      <img v-else class="resident-image-default resident-image small" alt="">
                    </div>
                    <div class="patient-result-info" style=" width: 35vw;">
                            <p v-if="item.personal_information"><b>Name:</b> {{item.personal_information?.last_name}}, {{item.personal_information?.first_name}}</p>

                            <p v-if="item.regulatory_information && item.regulatory_information.length"><b>{{item.regulatory_information[0].regulatory_type}}:</b>  {{ item.regulatory_information[0].data.slice(0,4)}} {{item.regulatory_information[0].data.slice(4, 9)}} {{item.regulatory_information[0].data.slice(9)}}</p>
                            <p v-else><b>Medicare Number:</b> N/A</p> 
                            <p><b>DOB:</b> {{item.personal_information && item.personal_information.dob ? item.personal_information.dob : ''}}</p>
                            <p><b>Location:</b> {{item.physical_location && item.physical_location.location ? item.physical_location.location.name : ''}}</p>
                            <p><b>Pharmacy:</b> {{item.pharmacy?.name ?? "N/A" }}</p>
                            <p v-if="item.primary_prescriber?.personal_information?.first_name && item.primary_prescriber?.personal_information?.last_name"><b>Primary Prescriber:</b> {{item.primary_prescriber?.personal_information?.first_name ?? "" }} {{item.primary_prescriber?.personal_information?.last_name ?? "" }}</p> 
                            <p v-else><b>Primary Prescriber:</b> N/A</p> 
                    </div>
                </div>
              </router-link>
            </div>
          </div>

          <div v-if="searched && !this.$store.getters.getPatients.length && !$store.state.loadingPatientsData">
              <h4>No results found.</h4>
          </div>

          <div v-if="!this.$store.getters.getPatients.length" style="margin: auto; width: 90vw; position: absolute; top: 50%; height: 50vh;">
              <h3><b>{{ $resident({ capitalize: true }) }} Search</b></h3>
              <span>Search by name or preferred name to find a {{ $resident() }}.</span>
          </div>

          <div v-if="$store.state.loadingPatientsData">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important; margin-top: 2em;"></i>
          </div>

        </div>
        <div v-else style="margin-top: 10em;">
          <h3 style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">
              You do not have permission to access this feature. Please talk to your admin if you require access.
          </h3>
        </div>
      </div>
    </div>
    <!-- <div class="drug-register-table table-container" style="padding-top: 10em; margin: 0 auto; height: 22em; margin-top: 5em;" >
      <h3 style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; height: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">This feature is not available yet.</h3>
    </div> -->
    <ResidentSyncModal v-if="displayResidentSyncModal" @close="close" :selectedFacility="currentFacility" />
  </div>
</template>


<script>
// @ is an alias to /src
import ResidentSyncModal from '@/components/modals/ResidentSyncModal.vue';
import { debounceSearch } from '@/services/debounce';

export default {
  props:['quickSearch'],
  components:{
    ResidentSyncModal,
  },
  data() {
    return {
      displayResidentSyncModal: false,
      searched: false,
      notReady: false,
      includeInactive: false,
      searchAll: false,
      currentFacility: null,
      // Assigned in created() rather than declared in methods - see services/debounce.js.
      debounceSearchForPatient: null,
      form: {
        page: 1
      }
    }
  },
  methods: {
    searchForPatient() {
      this.searchError = '';
      this.displayResults = true;
      this.searched = true;
      this.form.page = 1;
      // Call the getPatientSearchResults store function
      this.$store.dispatch('getPatientSearchResults', { search: this.searchTerm, page: this.form.page });
    },
    displayPage(page) {
      this.form.page = page;
      this.$store.dispatch('getPatientSearchResults', { search: this.searchTerm, page: this.form.page });
    },
    clearPatients() {
      this.$store.commit('setPatients', []);
      this.searchTerm = '';
      this.searched = false;
    },
    setInactive(){
      this.$store.commit('setInactive', this.includeInactive);
    },
    setSearchAll(){
      this.$store.commit('setSearchAll', this.searchAll);
    },
    close(value){
      if(value){
        this.displayResidentSyncModal = false;
      }
    }
  },
  mounted() {
    this.currentFacility = {
        facility_id:this.$store.state.currentLocation.facility.uuid, 
        integration_id: this.$store.state.user.integration_id, 
        integration_facility_id : this.$store.state.user.integration_facility_id
    }
    this.searchForPatient();
  },
  unmounted() {
    // Remove patients and search Term
    this.$store.commit('setPatients', []);
    this.$store.commit('setInactive', false);
    this.$store.commit('setSearchAll', false);
    this.searchTerm = '';
  },
  created(){
    this.debounceSearchForPatient = debounceSearch(() => this.searchForPatient());
    this.$watch(
      () => this.$route.params,
      () => {
        if (this.$route.params.quickSearch) {
          // Call the getPatientSearchResults store function
          this.$store.dispatch('getPatientSearchResults', { search: this.$route.params.quickSearch, page: 1 });
        }
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    )
  },
  computed:{
    sortedPatients() {
      let sortedResidents = this.$store.getters.getPatients;
      if (!sortedResidents) return [];

      return [...sortedResidents].sort((a,b) =>{

        const nameA = (a.personal_information?.last_name || "")?.toLowerCase() + " " + (a.personal_information?.first_name || "")?.toLowerCase();
        const nameB = (b.personal_information?.last_name || "")?.toLowerCase() + " " + (b.personal_information?.first_name || "")?.toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    },
    searchTerm: {
      get () {
        return this.$store.state.quickSearch
      },
      set (value) {
        this.$store.commit('setQuickSearch', value)
      }
    }
  }
}
</script>

<style lang="scss">
  .p-checkbox-box{
    margin: 0 !important;
  }
  
  .similar-name-tag-top {
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: #ff9800;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: bold;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    border: 2px solid white;
  }
</style>
